import { z } from 'zod';

/**
 * Версия этой сборки — МАЖОР.МИНОР из корневого version.json (vite/appVersionPlugin.ts, scripts/version.mjs).
 * Вне сборки приложения (Storybook, тесты) плагина нет — версия «0».
 */
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION ?? '0';

export const OZERO_DIGITAL_URL = 'https://ozero.digital';

/** Что выложено сейчас: /version.json рядом с index.html (кладёт vite/appVersionPlugin.ts). */
export const remoteVersionSchema = z.object({
  version: z.string().min(1),
  /** Версии ниже неё перезагружаются сразу. Поднимает критичный выпуск (version.mjs --critical). */
  minVersion: z.string().min(1).optional(),
});

export type RemoteVersion = z.infer<typeof remoteVersionSchema>;

/** current — обновлять нечего; available — плашка «Обновить»; required — перезагрузка сразу. */
export type UpdateVerdict = 'current' | 'available' | 'required';

/** МАЖОР.МИНОР по частям как числа: строкой «0.100» оказалась бы старше «0.99». */
function compareVersions(a: string, b: string): number {
  const pa = a.split('.').map(Number);
  const pb = b.split('.').map(Number);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const d = (pa[i] ?? 0) - (pb[i] ?? 0);
    if (d) return Math.sign(d);
  }
  return 0;
}

export function updateVerdict(current: string, remote: RemoteVersion): UpdateVerdict {
  if (remote.minVersion && compareVersions(current, remote.minVersion) < 0) return 'required';
  return compareVersions(current, remote.version) < 0 ? 'available' : 'current';
}

function getClientBuildDateIso(): string {
  const raw = import.meta.env.VITE_APP_BUILD_DATE;
  if (typeof raw === 'string' && raw.trim()) return raw.trim();
  return new Date().toISOString();
}

export function formatClientBuildDate(): string {
  const parsed = Date.parse(getClientBuildDateIso());
  if (!Number.isFinite(parsed)) return '—';
  try {
    return new Date(parsed).toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  } catch {
    return '—';
  }
}
